import axios from "axios";
import config from "../../config";

const BASE_URL = `${config.url}/api/subscriptions`;

const EmailSubscriptionManager = {
  // Create a new email subscription
  async createSubscription(payload) {
    const response = await axios.post(`${BASE_URL}/create`, payload);
    return response.data;
  },

  // Get all subscriptions
  async getAllSubscriptions() {
    const response = await axios.get(`${BASE_URL}/all`);
    return response.data;
  },

  // Get a subscription by ID
  async getSubscriptionById(id) {
    const response = await axios.get(`${BASE_URL}/${id}`);
    return response.data;
  },

  // Update a subscription by ID
  async updateSubscription(id, payload) {
    const response = await axios.put(`${BASE_URL}/update/${id}`, payload);
    return response.data;
  },

  // Delete a subscription by ID
  async deleteSubscription(id) {
    const response = await axios.delete(`${BASE_URL}/delete/${id}`);
    return response.data;
  },
};

export default EmailSubscriptionManager;
